export default (dt) => (
  new Date(dt * 1000).getDate()
)
